import { render, staticRenderFns } from "./FlotaForm.vue?vue&type=template&id=e882b65e"
import script from "./FlotaForm.vue?vue&type=script&lang=ts"
export * from "./FlotaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports